/** @format */

import {
  GET_QUESTIONNAIRE_CARD,
  SET_QUESTIONNAIRE_CARD,
  GET_QUESTIONNAIRE_INTRO,
  SET_QUESTIONNAIRE_INTRO,
  GET_QUESTIONNAIRE_SECTION,
  SET_QUESTIONNAIRE_SECTION,
  GET_QUESTIONNAIRE_PAGE,
  SET_QUESTIONNAIRE_PAGE,
  SET_QUESTIONNAIRE_ALLOWED_CHAR,
  SET_QUESTIONNAIRE_MENU,
  RESET_QUESTIONNAIRE,
  REFRESH_MENUS,
  MOVE_AWAY_TRUE,
  USER_IS_ON_QUESTIONNAIRE,
  SET_FORM_VALUES,
  SET_HAS_ERROR,
  SHOW_SPINNER,
  TOGGLE_USER_GUIDE,
  UPDATE_USER_GUIDE,
  UPDATE_CALL_BACK_PARAM,
  COMPLETE_MODEL_DIALOG_OPEN_CLOSE,
  ELEMENTED_UPDATED,
  DISPLAY_POPUP
} from './questionnaireTypes';
import { fetchQuestionnaireCard, fetchQuestionnaireIntro, fetchQuestionnaireSection } from 'src/services/questionnaire.service';
import {
  fetchShowOrganizer,
  persistShowOrganizer,
  wpGetAuditLogReportList,
  // createShowOrganizer
} from 'src/services/cms.service.js';

import { removeReadOnlyFromPayload } from 'src/helpers';
import { deriveMenuAndIndex } from './questionnaireReselect';
import { transformFormValues } from 'src/helpers';
import { getSupportedFileTypes as getSupportedFileTypesService } from 'src/services/documents.service.js';

const CREATEORGANIZER_PAGESTATES = {
  COMPLETE: 83, // only 83,84 seem to work?
  INCOMPLETE: 84,
  NOT_VISITED: 85,
  CURRENT_NOT_COMPLETE: 86,
  CURRENT_COMPLETE: 94,
  ENTITY_HEADER: 89,
};

export const setQuestionnaireCard = payload => ({
  type: SET_QUESTIONNAIRE_CARD,
  payload,
});

export const setQuestionnaireIntro = payload => ({
  type: SET_QUESTIONNAIRE_INTRO,
  payload,
});

export const setQuestionnaireSection = payload => ({
  type: SET_QUESTIONNAIRE_SECTION,
  payload,
});

export const setQuestionnairePage = payload => ({
  type: SET_QUESTIONNAIRE_PAGE,
  payload,
});

export const setQuestionnarieAllowedSpecialChar = (allowdSpecialChars, specialCharMsg) =>({
  type: SET_QUESTIONNAIRE_ALLOWED_CHAR,
  allowdSpecialChars,
  specialCharMsg
})

export const setQuestionnaireMenu = payload => ({
  type: SET_QUESTIONNAIRE_MENU,
  payload,
});

export const resetQuestionnaire = () => ({
  type: RESET_QUESTIONNAIRE,
});

export const refreshMenus = payload => ({
  type: REFRESH_MENUS,
  payload,
});
export const setMoveAwayQuestionnaireTrueFalse = payload => ({
  type: MOVE_AWAY_TRUE,
  payload,
});
export const setOnQuestionnairePageTrueFalse = payload => ({
  type: USER_IS_ON_QUESTIONNAIRE,
  payload,
});
export const setFormValuesQuestionnaire = payload => ({
  type: SET_FORM_VALUES,
  payload,
});
export const setUnsetHasError = payload => dispatch => {
  dispatch({ type: SET_HAS_ERROR, payload });
};

export const isCompleteModalDialogOpenClose = payload => ({
  type: COMPLETE_MODEL_DIALOG_OPEN_CLOSE,
  payload,
});

export const getQuestionnaireCard = languageId => {
  return async dispatch => {
    dispatch({ type: GET_QUESTIONNAIRE_CARD });
    const response = await fetchQuestionnaireCard({ languageId });
    if (response && response.success) {
      return dispatch(setQuestionnaireCard(response.messages));
    }
    if (response && response.error && response.error.code === 404) {
      return dispatch(setQuestionnaireCard({ isEmpty: true }));
    }
    if (!response || (response && response.success === false)) {
      return dispatch(setQuestionnaireCard({ isError: true }));
    }
  };
};

export const updateIsCompleteModalDialogOpenClose = payload => dispatch => {
  dispatch(isCompleteModalDialogOpenClose(payload));
};

export const getQuestionnaireIntro = (body, mock, callback) => {
  return async (dispatch, getState) => {
    dispatch({ type: GET_QUESTIONNAIRE_INTRO });
    const response = await fetchQuestionnaireIntro(body);
    // const response = await import('./questionnaireIntroResponse.json');
    if (response && response.success) {
      dispatch(setQuestionnaireIntro(response.messages));
      const newMenu = deriveMenuAndIndex(parseInt(body.pageId, 10), body.complete || false)(getState());
      dispatch(setQuestionnaireMenu(newMenu));
    }
    if (typeof callback === 'function') {
      callback();
    }
  };
};

export const getSupportedFileTypes = () => {
  return async () => {
    let applicantId = null;
    try {
      const headerDetailsObject = sessionStorage.getItem('headerDetails');
      const headerDetails = JSON.parse(headerDetailsObject);
      if (headerDetails && headerDetails.applicant) {
        applicantId = headerDetails.applicant.profileKey;
      }
    } catch (e) {
      console.trace('applicant.profileKey', e);
    }
    const response = await getSupportedFileTypesService(applicantId);
    if (response && response.supportedfileTypes && response.supportedfileTypes) {
      sessionStorage.setItem('supportedfileTypes', response.supportedfileTypes.join(','));
    }
  };
};

export const getQuestionnaireSection = body => {
  return async dispatch => {
    dispatch({ type: GET_QUESTIONNAIRE_SECTION });
    const response = await fetchQuestionnaireSection(body);
    // const response = await import('./getMenusPerSection.json');
    if (response && response.success) {
      dispatch(setQuestionnaireSection(response.messages));
    }
  };
};

export const getQuestionnairePage = (body, mock = false) => {
  return async (dispatch, getState) => {
    dispatch({ type: GET_QUESTIONNAIRE_PAGE });
    const response = mock
      ? await import('./manualFixShowOrganizerResponse.json')
      : await fetchShowOrganizer({
          ...body,
          lockGOAccess: true,
          showWelcomePage: false,
          isReadOnly: false,
        });

    if (response && response.success) {
      let {allowdSpecialChars, allowedValidationMessageSpecialChars} = response;
      if(allowdSpecialChars && allowedValidationMessageSpecialChars){
        dispatch(setQuestionnarieAllowedSpecialChar(allowdSpecialChars, allowedValidationMessageSpecialChars));
      }
      if (response.messages && response.messages.isAuditWPPage) {
        let mergeResonse = response.messages;
        const resposneGetAudit = await wpGetAuditLogReportList({
          organizerTypeId: response.messages.organizerTypeId,
          assigneeProfileId: response.messages.organizerInstanceId, // Test : 15699,
        });

        if (resposneGetAudit && resposneGetAudit.success) {
          mergeResonse.pageElements.push(resposneGetAudit.response);
          dispatch(setQuestionnairePage(mergeResonse));
        } else {
          dispatch(setQuestionnairePage(response.messages));
        }
      } else {
        dispatch(setQuestionnairePage(response.messages));
        // we will only derive the menu from one spot for now
        const newMenu = deriveMenuAndIndex(parseInt(body.pageId, 10), false)(getState());
        dispatch(setQuestionnaireMenu(newMenu));
      }

      // we will only derive the menu from one spot for now
      //const newMenu = deriveMenuAndIndex(parseInt(body.pageId, 10), false)(getState());
      //dispatch(setQuestionnaireMenu(newMenu));
    }
  };
};

export const updateMenu = (menus, body) => {
  return async (dispatch, getState) => {
    dispatch(refreshMenus(menus));
    const newMenu = deriveMenuAndIndex(parseInt(body.pageId, 10), body.complete || false)(getState());
    dispatch(setQuestionnaireMenu(newMenu));
  };
};

export const showHideMoveAwayPopUp = payload => dispatch => {
  return dispatch(setMoveAwayQuestionnaireTrueFalse(payload));
};

export const updateUserOnQuestionnaireTrueFalse = payload => dispatch => {
  dispatch(setOnQuestionnairePageTrueFalse(payload));
};

export const setUnsetFormValues = payload => dispatch => {
  dispatch(setFormValuesQuestionnaire(payload));
};

export const showSpinnerEnableDisable = payload => dispatch => {
  return dispatch({ type: SHOW_SPINNER, payload: payload });
};
export const toggleUserGuide = payload => dispatch => {
  return dispatch({ type: TOGGLE_USER_GUIDE, payload: payload });
};

export const updateImages = payload => dispatch => {
  return dispatch({ type: UPDATE_USER_GUIDE, data: payload });
};

export const updateCallBackParam = payload => dispatch => {
  return dispatch({ type: UPDATE_CALL_BACK_PARAM, data: payload });
};
// This method will be helpfull when user fill all the data  and then try to move away to other view like chat
// document , home etc . that time we shuld call this method which can persist form value anywhere.
export const persistOrg = (formValues, isFormComplete, page, callback = () => {}) => async dispatch => {
  // there's nothing to save on a menu page. we'll revisit this later

  const { organizerInstanceId, assigneeServicePlanGlobalId, yearTypeId, organizerTypeId, pageId, sourceTableId } = page;
  const pageState = isFormComplete ? CREATEORGANIZER_PAGESTATES.COMPLETE : CREATEORGANIZER_PAGESTATES.CURRENT_NOT_COMPLETE;

  formValues = removeReadOnlyFromPayload(formValues, page);

  const orgOptions = {
    assigneeServicePlanGlobalId,
    organizerInstanceId,
    organizerTypeId,
    yearTypeId,
    pageId,
    pageSourceId: sourceTableId,
    languageId: 1,
    pageState,
    ...transformFormValues(formValues),
  };

  const result = await persistShowOrganizer(orgOptions);
  if (result && result.success) {
    // console.log('Persisted'); // for future modification we can dispatch any action from here
  }
  callback();
};


export const elementUpdated = payload => ({
  type: ELEMENTED_UPDATED,
  payload,
});


export const displaySavePOPUP = payload => ({
  type: DISPLAY_POPUP,
  payload,
});
